import React, { useEffect, useState, useRef } from 'react';
import { IDLETIMER } from '../../../constants/defaults';
import Loader from '../Loader';
import CommonModal from '../Modal';
import './index.scss';
import { logOutUser2 } from '../../../services/Api/User/UserService';
import { useDispatch } from 'react-redux';
import { logoutClearStore } from '../../../actions/auth';
import { withRouter } from 'react-router-dom';
const { API } = require('../../../config/' + process.env.REACT_APP_ENV);

const IdleTimer = props => {
  const [openIdleModal, setOpenIdleModal] = useState(false);
  const [remaining, setRemaining] = useState(0);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const lang = props?.i18n?.language;

  // Refs for timers and modal state
  const idleTimeoutRef = useRef(null);
  const promptTimeoutRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const openIdleModalRef = useRef(false);

  // keep ref in sync with state
  useEffect(() => {
    openIdleModalRef.current = openIdleModal;
  }, [openIdleModal]);

  const clearAllTimers = () => {
    if (idleTimeoutRef.current) clearTimeout(idleTimeoutRef.current);
    if (promptTimeoutRef.current) clearTimeout(promptTimeoutRef.current);
    if (countdownIntervalRef.current)
      clearInterval(countdownIntervalRef.current);
  };

  const handleLogout = () => {
    setOpenIdleModal(false);
    setRemaining(0);
    dispatch(logoutClearStore());
    setLoader(true);

    logOutUser2().finally(() => {
      if (API.ALLOW_HOME_DELIVERY) {
        window.location.assign(`${decodeURI(API.GENIUS_AJAX_LOGOUT_URL)}`);
      } else {
        props.onLogOut();
        setLoader(false);
        lang === 'es'
          ? window.location.assign('/es')
          : window.location.assign('/');
      }
    });
  };

  const onLoggedOutClick = () => handleLogout();

  const showPrompt = () => {
    setOpenIdleModal(true);
    setRemaining(Math.ceil(IDLETIMER.DEFAULT_PROMPT_BEFORE_IDLE / 1000));

    countdownIntervalRef.current = setInterval(() => {
      setRemaining(prev => {
        if (prev <= 1) {
          clearInterval(countdownIntervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const resetTimer = () => {
    clearAllTimers();
    setOpenIdleModal(false);
    setRemaining(0);

    // schedule prompt-before-idle
    promptTimeoutRef.current = setTimeout(
      showPrompt,
      IDLETIMER.DEFAULT_TIMEOUT - IDLETIMER.DEFAULT_PROMPT_BEFORE_IDLE
    );

    // schedule final logout
    idleTimeoutRef.current = setTimeout(
      handleLogout,
      IDLETIMER.DEFAULT_TIMEOUT
    );
  };

  const handleStillHere = () => {
    setOpenIdleModal(false);
    resetTimer();
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

    const handleActivity = () => {
      //  Ignore activity while prompt is open (don’t auto-close it)
      if (openIdleModalRef.current) return;
      // ✅ Only when prompt is NOT open, reset the idle timers
      resetTimer();
    };

    events.forEach(e =>
      window.addEventListener(e, handleActivity, { passive: true })
    );

    resetTimer();

    return () => {
      events.forEach(e => window.removeEventListener(e, handleActivity));
      clearAllTimers();
    };
  }, []);

  return (
    <div className="sessionModal">
      {loader && <Loader />}
      {openIdleModal && (
        <CommonModal
          closeDialogHandler={() => setOpenIdleModal(false)}
          isInitialFocusToClose={true}
          isFocusOutside={true}
        >
          <div className="topHeading">Are you still there?</div>
          <div className="idleTimerConfirmModal">
            <p>
              Your session is about to timeout due to inactivity. You'll be
              signed out in {remaining}s.
            </p>
            <p>Want to stay signed in?</p>
            <div className="action-button">
              <button
                className="button deleteButton"
                onClick={onLoggedOutClick}
              >
                Sign out
              </button>
              <button onClick={handleStillHere} className="button neverButton">
                I’m here
              </button>
            </div>
          </div>
        </CommonModal>
      )}
    </div>
  );
};

export default withRouter(IdleTimer);
